export class SharedEngagementsConstants {
	public static readonly SEARCH_EDIT_RESULTS_KEY: string = 'SEARCH_EDIT_RESULTS';
	public static readonly SEARCH_RESULTS_KEY: string = 'SEARCH_RESULTS';

	public static readonly MAXIMUM_PORTFOLIOS: number = 7;

	public static readonly UPDATE_MODE = {
		EDIT: 'EDIT',
		NEW: 'NEW',
		CLONE: 'CLONE'
	};

	public static readonly DEFAULT_BPAS_BASE_CURRENCY_SELECTION_OPTION = 'GBP';
}
